// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"eO","newsTag":"eO","dafalut":"eP","qishou":"eQ","shangjia":"eR","shehui":"eS","caiwu":"eT","piyao":"eU","suanfa":"eV","keji":"eW","lingshou":"eX","gongzuo":"eY"};